module.exports = __webpack_public_path__ + "assets/img/side-navigation-expand-1ccd660b.png";